<script setup lang="ts">
import { Roles } from '@/constants'
import agentsHttpService from '@/services/http/agentsHttpService'
import { ref } from 'vue'

definePage({
  meta: { allowedRoles: [Roles.Admin] },
})

const rewardPercent = ref<number | null>(null)
const rewardPercentEdit = ref<number | null>(null)
const updatedAt = ref<string | null>(null)
const showDialog = ref(false)

const load = async () => {
  const res = await agentsHttpService.getAgentSettings()
  rewardPercent.value = res.rewardPercent
  updatedAt.value = res.updatedAt ?? null
}

const openDialog = () => {
  rewardPercentEdit.value = rewardPercent.value
  showDialog.value = true
}

const save = async () => {
  if (rewardPercentEdit.value === null || rewardPercentEdit.value < 0) return
  await agentsHttpService.updateAgentSettings(rewardPercentEdit.value)
  await load()
  showDialog.value = false
}

await load()
</script>

<template>
  <section class="flex flex-col gap-4 w-full">
    <Toast />
    <div class="flex justify-between items-center">
      <h2 class="text-2xl font-semibold">Настройки агентской программы</h2>
    </div>

    <DataTable
      :value="
        rewardPercent !== null
          ? [{ key: 'Агентское вознаграждение', value: `${rewardPercent}%`, updatedAt }]
          : []
      "
      dataKey="key"
    >
      <Column field="key" header="Параметр" />
      <Column field="value" header="Значение">
        <template #body="slotProps">
          <Tag :value="slotProps.data.value" severity="info" />
        </template>
      </Column>
      <Column field="updatedAt" header="Обновлено">
        <template #body="slotProps">
          {{
            slotProps.data.updatedAt
              ? new Date(slotProps.data.updatedAt).toLocaleString('ru-RU')
              : '—'
          }}
        </template>
      </Column>
      <Column header="Действия">
        <template #body>
          <Button label="Изменить" @click="openDialog" />
        </template>
      </Column>
      <template #empty>
        <div class="flex flex-col gap-4 items-center py-4">
          <span class="pi pi-cog text-6xl text-gray-300" />
          <p class="text-gray-500">Настройки не найдены</p>
        </div>
      </template>
    </DataTable>

    <Dialog
      v-model:visible="showDialog"
      header="Агентское вознаграждение"
      :modal="true"
      class="w-[90vw] sm:w-[400px]"
      :closable="true"
    >
      <div class="flex flex-col gap-4">
        <label for="rewardInput">Укажите % агентского вознаграждения</label>
        <InputNumber id="rewardInput" v-model="rewardPercentEdit" :min="0" :max="100" />
      </div>
      <template #footer>
        <div class="flex gap-2 justify-end">
          <Button label="Отмена" text @click="showDialog = false" />
          <Button label="Сохранить" @click="save" />
        </div>
      </template>
    </Dialog>
  </section>
</template>

<style scoped></style>
